(function () {
  const money = (amount, currency) => {
    const value = Number(amount || 0);
    return new Intl.NumberFormat('en-ZA', {
      style: 'currency',
      currency: currency || 'ZAR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value).replace(/\u00a0/g, '');
  };

  const selectedLabels = (root) => {
    return Array.from(root.querySelectorAll('variant-selects input[type="radio"]:checked'))
      .map((input) => input.value)
      .filter(Boolean);
  };

  const displayLabels = (root) => {
    return selectedLabels(root).map((value) => (/^unframed$/i.test(value) ? 'Unframed poster' : value));
  };

  const cleanMoney = (text) => {
    const source = String(text || '').replace(/\u00a0/g, ' ').trim();
    const match = source.match(/R\s*([\d,.]+)/i);
    if (!match) return source;
    const amount = Number(match[1].replace(/,/g, ''));
    if (!Number.isFinite(amount)) return source;
    const formatted = new Intl.NumberFormat('en-ZA', {
      minimumFractionDigits: amount % 1 ? 2 : 0,
      maximumFractionDigits: amount % 1 ? 2 : 0
    }).format(amount).replace(/\u00a0/g, '');
    return `${/^from\b/i.test(source) ? 'From ' : ''}R${formatted}`;
  };

  const formatPrices = (scope) => {
    (scope || document).querySelectorAll('.price-item').forEach((node) => {
      const formatted = cleanMoney(node.textContent);
      if (formatted && node.textContent.trim() !== formatted) node.textContent = formatted;
    });
  };

  const selectedPrice = (root) => {
    const price = root.querySelector('.price-item--sale, .price-item--regular');
    return price ? cleanMoney(price.textContent) : '';
  };

  const updateProductUI = (root) => {
    if (!root) return;
    formatPrices(root);
    const values = selectedLabels(root);
    setDeliveryEstimate(root);
    const price = selectedPrice(root);
    const priceHost = root.querySelector('[id^="price-"]');
    if (priceHost) {
      priceHost.classList.add('deco-price-row');
      let hint = priceHost.querySelector('.deco-variant-hint');
      if (!hint) {
        hint = document.createElement('span');
        hint.className = 'deco-variant-hint';
        priceHost.appendChild(hint);
      }
      hint.textContent = values.join(' · ');
    }
    const atc = root.querySelector('.product-form__submit:not([disabled]) > span');
    if (atc && price) atc.textContent = `Add to cart — ${price}`;

    const nudge = root.querySelector('[data-deco-format-nudge]');
    if (nudge) {
      const printOnly = values.some((value) => /unframed|print only/i.test(value));
      nudge.hidden = !printOnly;
    }

    const bar = document.querySelector('[data-deco-mobile-buybar]');
    if (bar) {
      const detail = bar.querySelector('[data-deco-mobile-detail]');
      if (detail) detail.textContent = [price, values.join(' · ')].filter(Boolean).join(' · ');
      const button = bar.querySelector('button');
      const mainButton = root.querySelector('.product-form__submit');
      if (button && mainButton) {
        button.disabled = mainButton.disabled;
        button.textContent = mainButton.disabled ? 'Unavailable' : 'Add to cart';
      }
    }
  };

  const ensureViewCartAction = (root) => {
    const buttons = root?.querySelector('.product-form__buttons');
    if (!buttons) return null;
    let link = buttons.querySelector('[data-deco-view-cart]');
    if (!link) {
      link = document.createElement('a');
      link.className = 'deco-view-cart';
      link.dataset.decoViewCart = '';
      link.href = window.routes?.cart_url || '/cart';
      link.textContent = 'View cart →';
      link.hidden = true;
      buttons.appendChild(link);
    }
    return link;
  };

  let addedStateTimer;
  const showAddedState = (root) => {
    if (!root) return;
    const button = root.querySelector('.product-form__submit:not([disabled])');
    const label = button?.querySelector(':scope > span');
    if (!button || !label) return;

    const selection = displayLabels(root).join(' · ');
    button.classList.add('deco-product-added');
    button.dataset.decoAdded = 'true';
    label.textContent = `Added${selection ? ` — ${selection}` : ''}`;
    button.setAttribute('aria-label', `Added${selection ? ` ${selection}` : ''}. Click to add another.`);

    const viewCart = ensureViewCartAction(root);
    if (viewCart) viewCart.hidden = false;

    window.clearTimeout(addedStateTimer);
    addedStateTimer = window.setTimeout(() => {
      button.classList.remove('deco-product-added');
      delete button.dataset.decoAdded;
      button.removeAttribute('aria-label');
      updateProductUI(root);
    }, 3200);
  };

  const setDeliveryEstimate = (root) => {
    const values = selectedLabels(root);
    const framed = values.some((value) => /^(black|white|wood|oak)$/i.test(value));

    document.querySelectorAll('[data-deco-delivery-date]').forEach((node) => {
      node.textContent = framed ? '8–10 working days' : '3–6 working days';
      const message = node.parentElement;
      if (message?.firstChild) message.firstChild.textContent = 'Production time: ';
    });
  };

  const initZoom = () => {
    if (!window.matchMedia('(pointer: fine)').matches) return;
    document.querySelectorAll('product-info .product__media-item:first-child .product__media').forEach((frame) => {
      const image = frame.querySelector('img');
      if (!image || frame.dataset.decoZoomReady) return;
      frame.dataset.decoZoomReady = 'true';
      frame.addEventListener('mousemove', (event) => {
        const box = frame.getBoundingClientRect();
        const x = ((event.clientX - box.left) / box.width) * 100;
        const y = ((event.clientY - box.top) / box.height) * 100;
        image.style.transformOrigin = `${x}% ${y}%`;
        image.style.transform = 'scale(1.5)';
      });
      frame.addEventListener('mouseleave', () => {
        image.style.transform = '';
        image.style.transformOrigin = '';
      });
    });
  };

  const decorateFramePills = (root) => {
    if (!root) return;
    root.querySelectorAll('.product-form__input--pill label').forEach((label) => {
      const value = label.textContent.trim().toLowerCase();
      const chips = {
        black: '#1C0003',
        white: '#FAF8F5',
        wood: 'linear-gradient(135deg,#b08954,#8a6a3e)',
        oak: 'linear-gradient(135deg,#d5bc95,#b99c70)'
      };
      if (chips[value]) {
        label.classList.add('deco-frame-label');
        label.style.setProperty('--deco-frame-chip', chips[value]);
      }
    });
  };

  const syncSizeGuide = (root) => {
    if (!root) return;
    const availableSizes = new Set(
      Array.from(root.querySelectorAll('variant-selects input[type="radio"]'))
        .map((input) => input.value.trim().toUpperCase())
        .filter((value) => /^A[1-4]$/.test(value))
    );
    document.querySelectorAll('[data-deco-size]').forEach((choice) => {
      const available = availableSizes.has(choice.dataset.decoSize.toUpperCase());
      choice.classList.toggle('deco-size-choice--unavailable', !available);
      choice.setAttribute('aria-disabled', available ? 'false' : 'true');
    });
  };

  const closeModal = (modal) => {
    if (!modal) return;
    modal.removeAttribute('open');
    document.documentElement.style.overflow = '';
  };

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-deco-size-guide-open]');
    if (open) {
      const modal = document.querySelector('[data-deco-size-modal]');
      if (modal) {
        modal.setAttribute('open', '');
        document.documentElement.style.overflow = 'hidden';
        modal.querySelector('.deco-size-modal__close')?.focus();
      }
      return;
    }

    const modal = event.target.closest('[data-deco-size-modal]');
    if (event.target.closest('[data-deco-size-modal-close]') || (modal && event.target === modal)) {
      closeModal(modal || document.querySelector('[data-deco-size-modal]'));
      return;
    }

    const size = event.target.closest('[data-deco-size]');
    if (size) {
      const value = size.dataset.decoSize;
      const root = document.querySelector('product-info');
      const input = Array.from(root?.querySelectorAll('variant-selects input[type="radio"]') || [])
        .find((candidate) => candidate.value.toUpperCase() === value.toUpperCase());
      if (input && !input.disabled) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      closeModal(document.querySelector('[data-deco-size-modal]'));
      return;
    }

    const stickyButton = event.target.closest('[data-deco-mobile-buybar] button');
    if (stickyButton) document.querySelector('product-info .product-form__submit:not([disabled])')?.click();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeModal(document.querySelector('[data-deco-size-modal][open]'));
  });

  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects')) {
      const root = document.querySelector('product-info');
      root?.querySelector('.product-form__submit')?.classList.remove('deco-product-added');
    }
  });

  const productVariants = (root) => {
    try {
      return JSON.parse(root?.querySelector('[data-deco-variants]')?.textContent || '[]');
    } catch {
      return [];
    }
  };

  const resolvedVariant = (root) => {
    const values = selectedLabels(root);
    return productVariants(root).find((variant) =>
      variant.options.length === values.length && variant.options.every((value, index) => value === values[index])
    );
  };

  const selectedFinish = (root) => {
    return selectedLabels(root).find((value) => /^(unframed|black|white|oak|wood)$/i.test(value)) || 'Unframed';
  };

  const mediaMatchesFinish = (alt, finish) => {
    const label = String(alt || '').toLowerCase();
    const normalizedFinish = String(finish || '').toLowerCase();
    if (normalizedFinish === 'unframed') {
      return label.includes('#unframed') || label.includes('full poster artwork');
    }
    if (normalizedFinish === 'wood') return label.includes('#oak') || label.includes('#wood');
    return label.includes(`#${normalizedFinish}`);
  };

  const syncGalleryForFinish = (root) => {
    const gallery = root?.querySelector('media-gallery');
    if (!gallery) return;

    const finish = selectedFinish(root);
    const mediaItems = Array.from(gallery.querySelectorAll('.product__media-item[data-media-id]'));
    let firstVisibleId = '';

    mediaItems.forEach((item) => {
      const allowed = mediaMatchesFinish(item.querySelector('img')?.alt, finish);
      item.hidden = !allowed;
      item.setAttribute('aria-hidden', allowed ? 'false' : 'true');
      if (allowed && !firstVisibleId) firstVisibleId = item.dataset.mediaId || '';

      const thumbnail = Array.from(gallery.querySelectorAll('.thumbnail-list__item[data-target]'))
        .find((candidate) => candidate.dataset.target === item.dataset.mediaId);
      if (thumbnail) {
        thumbnail.hidden = !allowed;
        thumbnail.setAttribute('aria-hidden', allowed ? 'false' : 'true');
      }
    });

    if (!firstVisibleId) return;
    const activeItem = gallery.querySelector('.product__media-item.is-active');
    if (activeItem?.dataset.mediaId === firstVisibleId && !activeItem.hidden) return;

    const targetThumbnail = Array.from(gallery.querySelectorAll('.thumbnail-list__item[data-target]'))
      .find((item) => item.dataset.target === firstVisibleId);
    targetThumbnail?.querySelector('button')?.click();
  };

  const syncResolvedVariant = (root) => {
    if (!root) return;
    updateOakA2Availability(root);
    const oakA2Unavailable = root.dataset.decoOakA2Unavailable === 'true';
    const variant = resolvedVariant(root);
    const button = root.querySelector('.product-form__submit');
    const label = button?.querySelector(':scope > span');
    const priceHost = root.querySelector('[id^="price-"]');
    const priceNode = priceHost?.querySelector('.price-item--sale, .price-item--regular');

    root.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {
      const variantId = variant?.id ? String(variant.id) : '';
      // Dawn can replace/reset this hidden field after a variant update. Set both
      // the live property and the HTML attribute so every product form stays aligned.
      if (input.value !== variantId) input.value = variantId;
      if (input.getAttribute('value') !== variantId) input.setAttribute('value', variantId);
      const enabled = Boolean(variant?.available) && !oakA2Unavailable;
      if (enabled) {
        input.disabled = false;
        input.removeAttribute('disabled');
      } else {
        input.disabled = true;
        input.setAttribute('disabled', '');
      }
    });

    if (!variant) {
      if (button) button.disabled = true;
      if (label) label.textContent = window.variantStrings?.unavailable || 'Unavailable';
      return;
    }

    const formattedPrice = money(variant.price / 100, root.querySelector('variant-selects')?.dataset.currencyCode);
    if (priceNode) priceNode.textContent = formattedPrice;
    if (priceHost) priceHost.classList.remove('hidden');
    if (button) button.disabled = !variant.available || oakA2Unavailable;
    if (label) {
      label.textContent = oakA2Unavailable
        ? 'Oak frame currently unavailable in A2'
        : variant.available
          ? `Add to cart — ${formattedPrice}`
          : window.variantStrings?.soldOut || 'Sold out';
    }

    if (root.dataset.updateUrl !== 'false') {
      window.history.replaceState({}, '', `${root.dataset.url}?variant=${variant.id}`);
    }

    syncGalleryForFinish(root);
    updateProductUI(root);
  };

  const updateOakA2Availability = (root) => {
    if (!root) return;
    const selected = selectedLabels(root).map((value) => value.trim().toLowerCase());
    const isA2 = selected.includes('a2');
    const oakInput = Array.from(root.querySelectorAll('variant-selects input[type="radio"]'))
      .find((input) => input.value.trim().toLowerCase() === 'oak');
    if (!oakInput) return;

    const oakLabel = root.querySelector(`label[for="${oakInput.id}"]`);
    const oakSelected = oakInput.checked;
    oakInput.disabled = isA2;
    oakInput.setAttribute('aria-disabled', isA2 ? 'true' : 'false');
    root.dataset.decoOakA2Unavailable = isA2 && oakSelected ? 'true' : 'false';

    if (oakLabel) {
      oakLabel.classList.toggle('deco-frame-label--unavailable', isA2);
      oakLabel.setAttribute('aria-disabled', isA2 ? 'true' : 'false');
      oakLabel.title = isA2 ? 'Oak frame currently unavailable in A2' : '';
    }

    let message = root.querySelector('[data-deco-oak-a2-message]');
    if (!message && oakLabel?.parentElement) {
      message = document.createElement('p');
      message.className = 'deco-frame-unavailable';
      message.dataset.decoOakA2Message = '';
      message.setAttribute('role', 'status');
      message.textContent = 'Oak frame currently unavailable in A2.';
      oakLabel.parentElement.insertAdjacentElement('afterend', message);
    }
    if (message) message.hidden = !isA2;
  };

  const init = () => {
    const root = document.querySelector('product-info');
    setDeliveryEstimate(root);
    decorateFramePills(root);
    updateOakA2Availability(root);
    syncSizeGuide(root);
    formatPrices(document);
    syncResolvedVariant(root);
    ensureViewCartAction(root);
    initZoom();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      const root = document.querySelector('product-info');
      syncResolvedVariant(root);
      window.requestAnimationFrame(() => syncResolvedVariant(document.querySelector('product-info')));
      [180, 900, 1800].forEach((delay) => {
        window.setTimeout(() => syncResolvedVariant(document.querySelector('product-info')), delay);
      });
    });
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source === 'product-form') showAddedState(document.querySelector('product-info'));
    });
  }


  const priceObserver = new MutationObserver(() => formatPrices(document));
  priceObserver.observe(document.documentElement, { childList: true, subtree: true });

  // Reconcile a delayed Dawn form replacement without changing the customer's
  // selection. This keeps the submitted variant in sync with the displayed price.
  let formRepairTimer;
  const formNeedsRepair = (root) => {
    const variant = resolvedVariant(root);
    if (!variant) return false;
    const expectedId = String(variant.id);
    const shouldBeDisabled = !variant.available || root.dataset.decoOakA2Unavailable === 'true';
    const inputs = Array.from(root.querySelectorAll('form[action*="/cart/add"] input[name="id"]'));
    return inputs.some((input) => String(input.value) !== expectedId || input.disabled !== shouldBeDisabled);
  };
  const scheduleFormRepair = () => {
    window.clearTimeout(formRepairTimer);
    formRepairTimer = window.setTimeout(() => {
      const root = document.querySelector('product-info');
      if (root && formNeedsRepair(root)) syncResolvedVariant(root);
    }, 0);
  };
  const productFormObserver = new MutationObserver(() => {
    const root = document.querySelector('product-info');
    if (root && formNeedsRepair(root)) scheduleFormRepair();
  });
  productFormObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['value', 'disabled']
  });

  // Last guard: write the resolved variant immediately before Dawn constructs
  // its cart request, even if its own component has reset the hidden input.
  document.addEventListener('submit', (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form?.matches('form[action*="/cart/add"]')) return;
    const root = document.querySelector('product-info');
    const variant = resolvedVariant(root);
    const input = form.querySelector('input[name="id"]');
    if (!variant || !input) return;
    const variantId = String(variant.id);
    input.value = variantId;
    input.setAttribute('value', variantId);
  }, true);
})();
